import i18n from '../../../utils/i18n'
import type { ProductUnit } from '../types/productUnit'
import { getProductUnitName } from './getProductUnitName'

// A saved value may have been translated under a UI language that isn't the current one (a
// different user, or a language changed since). Matching against every loaded UI language keeps
// a previously selected standard unit resolvable instead of falling back to a custom one.
export const getConfiguredUnitByValue = (units: ProductUnit[], value: string): ProductUnit | undefined => {
  const uiLanguages = Object.keys(i18n.options.resources ?? {})

  return units.find((unit) => uiLanguages.some((lng) => getProductUnitName(unit, i18n.t, lng) === value))
}
